import { useEffect } from 'react';
import type { ExchangeRate } from 'src/apis/exchangerate-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useExchangeRatesCurrent() {
  const current = useAxios(
    (axios, baseConfig) =>
      axios.request<ExchangeRate[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.exchangerateService}/api/exchange-rate`,
        method: 'GET',
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    current.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return current;
}

export type ExchangeRatesCurrentRequest = ReturnType<
  typeof useExchangeRatesCurrent
>;

export function useOptionalExchangeRatesCurrent() {
  const current = useAxios(
    (axios, baseConfig) =>
      axios.request<ExchangeRate[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.exchangerateService}/api/exchange-rate`,
        method: 'GET',
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        return error;
      },
    }
  );

  useEffect(() => {
    current.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return current;
}

export type OptionalExchangeRatesCurrentRequest = ReturnType<
  typeof useOptionalExchangeRatesCurrent
>;
